import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appDragClose]',
    standalone: false
})
export class DragCloseDirective implements OnInit {
  @Input() dragThreshold = 100;
  @Output() dragClose = new EventEmitter<void>();

  private isDragging = false;
  private startY = 0;
  private currentY = 0;
  private modalHeight = 0;
  private modalElement: HTMLElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.modalElement = this.el.nativeElement.closest('.offcanvas, .modal');
    if (this.modalElement) {
      this.modalHeight = this.modalElement.offsetHeight;
    }
  }

  @HostListener('touchstart', ['$event'])
  @HostListener('mousedown', ['$event'])
  onDragStart(e: TouchEvent | MouseEvent) {
    const target = e.target as HTMLElement;

    if (target.closest('.no-drag, .btn-close')) {
      return;
    }

    this.isDragging = true;
    this.startY = e.type === 'touchstart'
      ? (e as TouchEvent).touches[0].clientY
      : (e as MouseEvent).clientY;

    if (this.modalElement) {
      this.modalElement.classList.add('dragging');
    }

    e.preventDefault();
  }


  @HostListener('touchmove', ['$event'])
  @HostListener('document:mousemove', ['$event'])
  onDragMove(e: TouchEvent | MouseEvent) {
    if (!this.isDragging || !this.modalElement) return;

    this.currentY = e.type === 'touchmove'
      ? (e as TouchEvent).touches[0].clientY
      : (e as MouseEvent).clientY;

    const deltaY = this.currentY - this.startY;
    if (deltaY > 0) {
      const dragPercent = deltaY / this.modalHeight;
      const opacity = Math.max(0.3, 1 - dragPercent);

      this.renderer.setStyle(this.modalElement, 'transform', `translateY(${deltaY}px)`);
      this.renderer.setStyle(this.modalElement, 'opacity', opacity.toString());

      if (deltaY > this.dragThreshold) {
        this.modalElement.classList.add('drag-threshold');
      } else {
        this.modalElement.classList.remove('drag-threshold');
      }
    }
  }

  @HostListener('touchend')
  @HostListener('document:mouseup')
  onDragEnd() {
    if (!this.isDragging || !this.modalElement) return;

    this.isDragging = false;
    const deltaY = this.currentY - this.startY;

    this.modalElement.classList.remove('dragging');

    if (deltaY > this.dragThreshold) {
      this.dragClose.emit();
    } else {
      this.renderer.removeStyle(this.modalElement, 'transform');
      this.renderer.removeStyle(this.modalElement, 'opacity');
      this.modalElement.classList.remove('drag-threshold');
    }

    this.startY = 0;
    this.currentY = 0;
  }
}